import React from "react";

const EarlyOutcome = ({
  formData,
  handleChange,
  handleCheckboxChange,
  dtDisplay,
}) => {
  // 라디오 버튼 전용 핸들러 - 간단한 재클릭 해제 로직
  const handleRadioClick = (e) => {
    const { name, value } = e.target;

    // 현재 선택된 값과 클릭된 값이 같으면 해제, 다르면 선택
    if (formData[name] === value) {
      handleChange({ target: { name, value: "" } });
    } else {
      handleChange({ target: { name, value } });
    }
  };

  // 복사-붙여넣기 자동 포맷팅 핸들러
  const handlePaste = (e, fieldName) => {
    e.preventDefault(); // 기본 붙여넣기 동작 방지

    const pastedData = e.clipboardData.getData("text");
    const numbers = pastedData.replace(/\D/g, ""); // 숫자만 추출

    if (numbers.length <= 12) {
      // 자동 포맷팅 적용
      let formattedValue = numbers;

      if (numbers.length >= 4) {
        formattedValue = numbers.slice(0, 4) + "-" + numbers.slice(4);
      }
      if (numbers.length >= 6) {
        formattedValue =
          formattedValue.slice(0, 7) + "-" + formattedValue.slice(7);
      }
      if (numbers.length >= 8) {
        formattedValue =
          formattedValue.slice(0, 10) + " " + formattedValue.slice(10);
      }
      if (numbers.length >= 10) {
        formattedValue =
          formattedValue.slice(0, 13) + ":" + formattedValue.slice(13);
      }

      // 포맷된 값으로 필드 업데이트
      handleChange({
        target: { name: fieldName, value: formattedValue },
      });
    }
  };

  // 섹션 제목 가져오기
  const getSectionTitle = () => {
    switch (formData.index_injury) {
      case "TBI":
        return "TBI neurologic deterioration";
      case "SAH (ruptured aneurysm)":
        return "SAH neurologic deterioration";
      case "ICH (primary, secondary) / IVH":
        return "ICH neurologic deterioration";
      default:
        return "Early Outcome";
    }
  };

  // TBI 관련 필드
  const renderTBIFields = () => (
    <>
      {/* ND1 섹션 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            TBI neurologic deterioration 일시 (tbi_nd1_dt)
          </label>
          <div className="input_2col">
            <input
              type="text"
              name="tbi_nd1_dt"
              placeholder="YYYY-MM-DD HH:MM"
              value={dtDisplay(formData.tbi_nd1_dt)}
              onChange={(e) => {
                const input = e.target.value;
                const currentValue = dtDisplay(formData.tbi_nd1_dt) || "";

                // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                if (input.length < currentValue.length) {
                  handleChange(e);
                  return;
                }

                // 숫자만 추출
                const numbers = input.replace(/\D/g, "");

                if (numbers.length <= 12) {
                  // 최대 12자리 (YYYYMMDDHHmm)
                  let formattedValue = numbers;

                  // 날짜 시간 포맷팅
                  if (numbers.length >= 4) {
                    formattedValue =
                      numbers.slice(0, 4) + "-" + numbers.slice(4);
                  }
                  if (numbers.length >= 6) {
                    formattedValue =
                      formattedValue.slice(0, 7) +
                      "-" +
                      formattedValue.slice(7);
                  }
                  if (numbers.length >= 8) {
                    formattedValue =
                      formattedValue.slice(0, 10) +
                      " " +
                      formattedValue.slice(10);
                  }
                  if (numbers.length >= 10) {
                    formattedValue =
                      formattedValue.slice(0, 13) +
                      ":" +
                      formattedValue.slice(13);
                  }

                  // 원래의 handleChange 함수 호출
                  handleChange({
                    target: {
                      name: "tbi_nd1_dt",
                      value: formattedValue,
                    },
                  });
                }
              }}
              onPaste={(e) => handlePaste(e, "tbi_nd1_dt")}
            />
          </div>
        </div>
        <div className="block-2column" />
      </div>

      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            TBI neurologic deterioration 여부 (tbi_nd1)
          </label>
          <div className="input_2col">
            <div className="rad-group">
              {[
                { label: "Yes", value: "1" },
                { label: "No", value: "0" },
              ].map((option) => (
                <label key={option.value} className="rad-label vertical">
                  <input
                    type="radio"
                    className="rad-input"
                    name="tbi_nd1"
                    value={option.value}
                    checked={formData.tbi_nd1 === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
        <div className="block-2column">
          <label className="item_title_2col">
            TBI neurologic deterioration 원인 (tbi_nd1_cause)
          </label>
          <div className="input_2col">
            <div className="rad-group vertical">
              {[
                { label: "Hematoma expansion", value: "1" },
                { label: "Cerebral edema", value: "2" },
                { label: "Hydrocephalus", value: "3" },
                { label: "Cerebral Infarction", value: "4" },
                { label: "Seizure", value: "5" },
                { label: "New cerebral hemorrhage", value: "6" },
                {
                  label: "Medical complication (electro, sepsis...)",
                  value: "7",
                },
                { label: "Others, specify", value: "99" },
              ].map((option) => (
                <label key={option.value} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="tbi_nd1_cause"
                    value={option.value}
                    checked={formData.tbi_nd1_cause === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            TBI neurologic deterioration 원인_others (tbi_nd1_cause_others)
          </label>
          <div className="input_2col">
            <input
              type="text"
              name="tbi_nd1_cause_others"
              value={formData.tbi_nd1_cause_others || ""}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>

      {/* ND2 섹션 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            TBI neurologic deterioration 일시 (tbi_nd2_dt)
          </label>
          <div className="input_2col">
            <input
              type="text"
              name="tbi_nd2_dt"
              placeholder="YYYY-MM-DD HH:MM"
              value={dtDisplay(formData.tbi_nd2_dt)}
              onChange={(e) => {
                const input = e.target.value;
                const currentValue = dtDisplay(formData.tbi_nd2_dt) || "";

                // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                if (input.length < currentValue.length) {
                  handleChange(e);
                  return;
                }

                // 숫자만 추출
                const numbers = input.replace(/\D/g, "");

                if (numbers.length <= 12) {
                  // 최대 12자리 (YYYYMMDDHHmm)
                  let formattedValue = numbers;

                  // 날짜 시간 포맷팅
                  if (numbers.length >= 4) {
                    formattedValue =
                      numbers.slice(0, 4) + "-" + numbers.slice(4);
                  }
                  if (numbers.length >= 6) {
                    formattedValue =
                      formattedValue.slice(0, 7) +
                      "-" +
                      formattedValue.slice(7);
                  }
                  if (numbers.length >= 8) {
                    formattedValue =
                      formattedValue.slice(0, 10) +
                      " " +
                      formattedValue.slice(10);
                  }
                  if (numbers.length >= 10) {
                    formattedValue =
                      formattedValue.slice(0, 13) +
                      ":" +
                      formattedValue.slice(13);
                  }

                  // 원래의 handleChange 함수 호출
                  handleChange({
                    target: {
                      name: "tbi_nd2_dt",
                      value: formattedValue,
                    },
                  });
                }
              }}
              onPaste={(e) => handlePaste(e, "tbi_nd2_dt")}
            />
          </div>
        </div>
        <div className="block-2column" />
      </div>

      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            TBI neurologic deterioration 여부 (tbi_nd2)
          </label>
          <div className="input_2col">
            <div className="rad-group">
              {[
                { label: "Yes", value: "1" },
                { label: "No", value: "0" },
              ].map((option) => (
                <label key={option.value} className="rad-label vertical">
                  <input
                    type="radio"
                    className="rad-input"
                    name="tbi_nd2"
                    value={option.value}
                    checked={formData.tbi_nd2 === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
        <div className="block-2column">
          <label className="item_title_2col">
            TBI neurologic deterioration 원인 (tbi_nd2_cause)
          </label>
          <div className="input_2col">
            <div className="rad-group vertical">
              {[
                { label: "Hematoma expansion", value: "1" },
                { label: "Cerebral edema", value: "2" },
                { label: "Hydrocephalus", value: "3" },
                { label: "Cerebral Infarction", value: "4" },
                { label: "Seizure", value: "5" },
                { label: "New cerebral hemorrhage", value: "6" },
                {
                  label: "Medical complication (electro, sepsis...)",
                  value: "7",
                },
                { label: "Others, specify", value: "99" },
              ].map((option) => (
                <label key={option.value} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="tbi_nd2_cause"
                    value={option.value}
                    checked={formData.tbi_nd2_cause === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            TBI neurologic deterioration 원인_others (tbi_nd2_cause_others)
          </label>
          <div className="input_2col">
            <input
              type="text"
              name="tbi_nd2_cause_others"
              value={formData.tbi_nd2_cause_others || ""}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>

      {/* ND3 섹션 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            TBI neurologic deterioration 일시 (tbi_nd3_dt)
          </label>
          <div className="input_2col">
            <input
              type="text"
              name="tbi_nd3_dt"
              placeholder="YYYY-MM-DD HH:MM"
              value={dtDisplay(formData.tbi_nd3_dt)}
              onChange={(e) => {
                const input = e.target.value;
                const currentValue = dtDisplay(formData.tbi_nd3_dt) || "";

                // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                if (input.length < currentValue.length) {
                  handleChange(e);
                  return;
                }

                // 숫자만 추출
                const numbers = input.replace(/\D/g, "");

                if (numbers.length <= 12) {
                  // 최대 12자리 (YYYYMMDDHHmm)
                  let formattedValue = numbers;

                  // 날짜 시간 포맷팅
                  if (numbers.length >= 4) {
                    formattedValue =
                      numbers.slice(0, 4) + "-" + numbers.slice(4);
                  }
                  if (numbers.length >= 6) {
                    formattedValue =
                      formattedValue.slice(0, 7) +
                      "-" +
                      formattedValue.slice(7);
                  }
                  if (numbers.length >= 8) {
                    formattedValue =
                      formattedValue.slice(0, 10) +
                      " " +
                      formattedValue.slice(10);
                  }
                  if (numbers.length >= 10) {
                    formattedValue =
                      formattedValue.slice(0, 13) +
                      ":" +
                      formattedValue.slice(13);
                  }

                  // 원래의 handleChange 함수 호출
                  handleChange({
                    target: {
                      name: "tbi_nd3_dt",
                      value: formattedValue,
                    },
                  });
                }
              }}
              onPaste={(e) => handlePaste(e, "tbi_nd3_dt")}
            />
          </div>
        </div>
        <div className="block-2column" />
      </div>

      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            TBI neurologic deterioration 여부 (tbi_nd3)
          </label>
          <div className="input_2col">
            <div className="rad-group">
              {[
                { label: "Yes", value: "1" },
                { label: "No", value: "0" },
              ].map((option) => (
                <label key={option.value} className="rad-label vertical">
                  <input
                    type="radio"
                    className="rad-input"
                    name="tbi_nd3"
                    value={option.value}
                    checked={formData.tbi_nd3 === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
        <div className="block-2column">
          <label className="item_title_2col">
            TBI neurologic deterioration 원인 (tbi_nd3_cause)
          </label>
          <div className="input_2col">
            <div className="rad-group vertical">
              {[
                { label: "Hematoma expansion", value: "1" },
                { label: "Cerebral edema", value: "2" },
                { label: "Hydrocephalus", value: "3" },
                { label: "Cerebral Infarction", value: "4" },
                { label: "Seizure", value: "5" },
                { label: "New cerebral hemorrhage", value: "6" },
                {
                  label: "Medical complication (electro, sepsis...)",
                  value: "7",
                },
                { label: "Others, specify", value: "99" },
              ].map((option) => (
                <label key={option.value} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="tbi_nd3_cause"
                    value={option.value}
                    checked={formData.tbi_nd3_cause === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            TBI neurologic deterioration 원인_others (tbi_nd3_cause_others)
          </label>
          <div className="input_2col">
            <input
              type="text"
              name="tbi_nd3_cause_others"
              value={formData.tbi_nd3_cause_others || ""}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>
    </>
  );

  // SAH 관련 필드
  const renderSAHFields = () => (
    <>
      {/* ND1 섹션 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            SAH neurologic deterioration 일시 (sah_nd1_dt)
          </label>
          <div className="input_2col">
            <input
              type="text"
              name="sah_nd1_dt"
              placeholder="YYYY-MM-DD HH:MM"
              value={dtDisplay(formData.sah_nd1_dt)}
              onChange={(e) => {
                const input = e.target.value;
                const currentValue = dtDisplay(formData.sah_nd1_dt) || "";

                // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                if (input.length < currentValue.length) {
                  handleChange(e);
                  return;
                }

                // 숫자만 추출
                const numbers = input.replace(/\D/g, "");

                if (numbers.length <= 12) {
                  // 최대 12자리 (YYYYMMDDHHmm)
                  let formattedValue = numbers;

                  // 날짜 시간 포맷팅
                  if (numbers.length >= 4) {
                    formattedValue =
                      numbers.slice(0, 4) + "-" + numbers.slice(4);
                  }
                  if (numbers.length >= 6) {
                    formattedValue =
                      formattedValue.slice(0, 7) +
                      "-" +
                      formattedValue.slice(7);
                  }
                  if (numbers.length >= 8) {
                    formattedValue =
                      formattedValue.slice(0, 10) +
                      " " +
                      formattedValue.slice(10);
                  }
                  if (numbers.length >= 10) {
                    formattedValue =
                      formattedValue.slice(0, 13) +
                      ":" +
                      formattedValue.slice(13);
                  }

                  // 원래의 handleChange 함수 호출
                  handleChange({
                    target: {
                      name: "sah_nd1_dt",
                      value: formattedValue,
                    },
                  });
                }
              }}
            />
          </div>
        </div>

        <div className="block-2column" />
      </div>
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            SAH neurologic deterioration 여부 (sah_nd1)
          </label>
          <div className="input_2col">
            <div className="rad-group">
              {[
                { label: "No", value: "No" },
                { label: "Yes", value: "Yes" },
              ].map((option) => (
                <label key={option.value} className="rad-label vertical">
                  <input
                    type="radio"
                    className="rad-input"
                    name="sah_nd1"
                    value={option.value}
                    checked={formData.sah_nd1 === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>

        <div className="block-2column">
          <label className="item_title_2col">
            SAH neurologic deterioration 원인 (sah_nd1_cause)
          </label>
          <div className="input_2col">
            <div className="rad-group vertical">
              {[
                { label: "DCI(ischemia)", value: "DCI(ischemia)" },
                { label: "Hydrocephalus", value: "Hydrocephalus" },
                { label: "Rebleeding", value: "Rebleeding" },
                { label: "Infarction", value: "Infarction" },
                { label: "Seizure", value: "Seizure" },
                {
                  label: "Intracranial complication (edema, iicp, ich, sdh...)",
                  value: "Intracranial complication (edema, iicp, ich, sdh...)",
                },
                {
                  label: "Systemic complication (electro, sepsis...)",
                  value: "Systemic complication (electro, sepsis...)",
                },
                { label: "Others, specify", value: "Others, specify" },
              ].map((option) => (
                <label key={option.value} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="sah_nd1_cause"
                    value={option.value}
                    checked={formData.sah_nd1_cause === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            SAH neurologic deterioration 원인 (sah_nd1_cause_others)
          </label>
          <div className="input_2col">
            <input
              type="text"
              name="sah_nd1_cause_others"
              value={formData.sah_nd1_cause_others || ""}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>
      {/* ND2 섹션 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            SAH neurologic deterioration 일시 (sah_nd2_dt)
          </label>
          <div className="input_2col">
            <input
              type="text"
              name="sah_nd2_dt"
              placeholder="YYYY-MM-DD HH:MM"
              value={dtDisplay(formData.sah_nd2_dt)}
              onChange={(e) => {
                const input = e.target.value;
                const currentValue = dtDisplay(formData.sah_nd2_dt) || "";

                // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                if (input.length < currentValue.length) {
                  handleChange(e);
                  return;
                }

                // 숫자만 추출
                const numbers = input.replace(/\D/g, "");

                if (numbers.length <= 12) {
                  // 최대 12자리 (YYYYMMDDHHmm)
                  let formattedValue = numbers;

                  // 날짜 시간 포맷팅
                  if (numbers.length >= 4) {
                    formattedValue =
                      numbers.slice(0, 4) + "-" + numbers.slice(4);
                  }
                  if (numbers.length >= 6) {
                    formattedValue =
                      formattedValue.slice(0, 7) +
                      "-" +
                      formattedValue.slice(7);
                  }
                  if (numbers.length >= 8) {
                    formattedValue =
                      formattedValue.slice(0, 10) +
                      " " +
                      formattedValue.slice(10);
                  }
                  if (numbers.length >= 10) {
                    formattedValue =
                      formattedValue.slice(0, 13) +
                      ":" +
                      formattedValue.slice(13);
                  }

                  // 원래의 handleChange 함수 호출
                  handleChange({
                    target: {
                      name: "sah_nd2_dt",
                      value: formattedValue,
                    },
                  });
                }
              }}
              onPaste={(e) => handlePaste(e, "sah_nd2_dt")}
            />
          </div>
        </div>

        <div className="block-2column" />
      </div>
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            SAH neurologic deterioration 여부 (sah_nd2)
          </label>
          <div className="input_2col">
            <div className="rad-group">
              {[
                { label: "No", value: "No" },
                { label: "Yes", value: "Yes" },
              ].map((option) => (
                <label key={option.value} className="rad-label vertical">
                  <input
                    type="radio"
                    className="rad-input"
                    name="sah_nd2"
                    value={option.value}
                    checked={formData.sah_nd2 === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>

        <div className="block-2column">
          <label className="item_title_2col">
            SAH neurologic deterioration 원인 (sah_nd2_cause)
          </label>
          <div className="input_2col">
            <div className="rad-group vertical">
              {[
                { label: "DCI(ischemia)", value: "DCI(ischemia)" },
                { label: "Hydrocephalus", value: "Hydrocephalus" },
                { label: "Rebleeding", value: "Rebleeding" },
                { label: "Infarction", value: "Infarction" },
                { label: "Seizure", value: "Seizure" },
                {
                  label: "Intracranial complication (edema, iicp, ich, sdh...)",
                  value: "Intracranial complication (edema, iicp, ich, sdh...)",
                },
                {
                  label: "Systemic complication (electro, sepsis...)",
                  value: "Systemic complication (electro, sepsis...)",
                },
                { label: "Others, specify", value: "Others, specify" },
              ].map((option) => (
                <label key={option.value} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="sah_nd2_cause"
                    value={option.value}
                    checked={formData.sah_nd2_cause === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            SAH neurologic deterioration 원인 (sah_nd2_cause_others)
          </label>
          <div className="input_2col">
            <input
              type="text"
              name="sah_nd2_cause_others"
              value={formData.sah_nd2_cause_others || ""}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>
      {/* ND3 섹션 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            SAH neurologic deterioration 일시 (sah_nd3_dt)
          </label>
          <div className="input_2col">
            <input
              type="text"
              name="sah_nd3_dt"
              placeholder="YYYY-MM-DD HH:MM"
              value={dtDisplay(formData.sah_nd3_dt)}
              onChange={(e) => {
                const input = e.target.value;
                const currentValue = dtDisplay(formData.sah_nd3_dt) || "";

                // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                if (input.length < currentValue.length) {
                  handleChange(e);
                  return;
                }

                // 숫자만 추출
                const numbers = input.replace(/\D/g, "");

                if (numbers.length <= 12) {
                  // 최대 12자리 (YYYYMMDDHHmm)
                  let formattedValue = numbers;

                  // 날짜 시간 포맷팅
                  if (numbers.length >= 4) {
                    formattedValue =
                      numbers.slice(0, 4) + "-" + numbers.slice(4);
                  }
                  if (numbers.length >= 6) {
                    formattedValue =
                      formattedValue.slice(0, 7) +
                      "-" +
                      formattedValue.slice(7);
                  }
                  if (numbers.length >= 8) {
                    formattedValue =
                      formattedValue.slice(0, 10) +
                      " " +
                      formattedValue.slice(10);
                  }
                  if (numbers.length >= 10) {
                    formattedValue =
                      formattedValue.slice(0, 13) +
                      ":" +
                      formattedValue.slice(13);
                  }

                  // 원래의 handleChange 함수 호출
                  handleChange({
                    target: {
                      name: "sah_nd3_dt",
                      value: formattedValue,
                    },
                  });
                }
              }}
            />
          </div>
        </div>

        <div className="block-2column" />
      </div>
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            SAH neurologic deterioration 여부 (sah_nd3)
          </label>
          <div className="input_2col">
            <div className="rad-group">
              {[
                { label: "No", value: "No" },
                { label: "Yes", value: "Yes" },
              ].map((option) => (
                <label key={option.value} className="rad-label vertical">
                  <input
                    type="radio"
                    className="rad-input"
                    name="sah_nd3"
                    value={option.value}
                    checked={formData.sah_nd3 === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>

        <div className="block-2column">
          <label className="item_title_2col">
            SAH neurologic deterioration 원인 (sah_nd3_cause)
          </label>
          <div className="input_2col">
            <div className="rad-group vertical">
              {[
                { label: "DCI(ischemia)", value: "DCI(ischemia)" },
                { label: "Hydrocephalus", value: "Hydrocephalus" },
                { label: "Rebleeding", value: "Rebleeding" },
                { label: "Infarction", value: "Infarction" },
                { label: "Seizure", value: "Seizure" },
                {
                  label: "Intracranial complication (edema, iicp, ich, sdh...)",
                  value: "Intracranial complication (edema, iicp, ich, sdh...)",
                },
                {
                  label: "Systemic complication (electro, sepsis...)",
                  value: "Systemic complication (electro, sepsis...)",
                },
                { label: "Others, specify", value: "Others, specify" },
              ].map((option) => (
                <label key={option.value} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="sah_nd3_cause"
                    value={option.value}
                    checked={formData.sah_nd3_cause === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            SAH neurologic deterioration 원인 (sah_nd3_cause_others)
          </label>
          <div className="input_2col">
            <input
              type="text"
              name="sah_nd3_cause_others"
              value={formData.sah_nd3_cause_others || ""}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>
      <h3 className="section-subtitle">SAH</h3>
      {/* DCI 관련 필드들 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            SAH delayed cerebral ischemia 발생 여부 (sah_dci)
          </label>
          <div className="input_2col">
            <div className="rad-group">
              {[
                { label: "No", value: "No" },
                { label: "Yes", value: "Yes" },
              ].map((option) => (
                <label key={option.value} className="rad-label vertical">
                  <input
                    type="radio"
                    className="rad-input"
                    name="sah_dci"
                    value={option.value}
                    checked={formData.sah_dci === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>

        <div className="block-2column">
          <label className="item_title_2col">
            Subarachnoid hemorrhage clinical deterioration infarction delayed
            cerebral ischemia indicator (sah_dci_infarct)
          </label>
          <div className="input_2col">
            <div className="rad-group">
              {[
                { label: "No", value: "No" },
                { label: "Yes", value: "Yes" },
              ].map((option) => (
                <label key={option.value} className="rad-label vertical">
                  <input
                    type="radio"
                    className="rad-input"
                    name="sah_dci_infarct"
                    value={option.value}
                    checked={formData.sah_dci_infarct === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* Angiographic spasm 관련 필드들 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            Angiographic spasm 발생 여부 (sah_angio_spasm)
          </label>
          <div className="input_2col">
            <div className="rad-group vertical">
              {[
                { label: "None", value: "None" },
                {
                  label: "DSA proven vasospasm",
                  value: "DSA proven vasospasm",
                },
                {
                  label: "Vasospasm suspected on CTA or MRA",
                  value: "Vasospasm suspected on CTA or MRA",
                },
              ].map((option) => (
                <label key={option.value} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="sah_angio_spasm"
                    value={option.value}
                    checked={formData.sah_angio_spasm === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>

        <div className="block-2column">
          <label className="item_title_2col">
            Symptomatic vasospasm 여부 (sah_angio_spasm_symptom)
          </label>
          <div className="input_2col">
            <div className="rad-group vertical">
              {[
                { label: "Asymptomatic", value: "Asymptomatic" },
                { label: "Symptomatic", value: "Symptomatic" },
                {
                  label: "Unknown (Deep sedation 등)",
                  value: "Unknown (Deep sedation 등)",
                },
              ].map((option) => (
                <label key={option.value} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="sah_angio_spasm_symptom"
                    value={option.value}
                    checked={formData.sah_angio_spasm_symptom === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            Vasospasm degree (sah_angio_spasm_degree)
          </label>
          <div className="input_2col">
            <div className="rad-group vertical">
              {[
                { label: "Mild", value: "Mild" },
                { label: "Moderate", value: "Moderate" },
                { label: "Severe", value: "Severe" },
              ].map((option) => (
                <label key={option.value} className="rad-label vertical">
                  <input
                    type="radio"
                    className="rad-input"
                    name="sah_angio_spasm_degree"
                    value={option.value}
                    checked={formData.sah_angio_spasm_degree === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>

        <div className="block-2column">
          <label className="item_title_2col">
            Vasospasm extent (sah_angio_spasm_extent)
          </label>
          <div className="input_2col">
            <div className="rad-group vertical">
              {[
                { label: "Focal", value: "Focal" },
                { label: "Diffuse", value: "Diffuse" },
              ].map((option) => (
                <label key={option.value} className="rad-label vertical">
                  <input
                    type="radio"
                    className="rad-input"
                    name="sah_angio_spasm_extent"
                    value={option.value}
                    checked={formData.sah_angio_spasm_extent === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* TCD spasm 관련 필드들 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            TCD spasm 발생 여부 (sah_tcd_spasm)
          </label>
          <div className="input_2col">
            <div className="rad-group vertical">
              {[
                { label: "No", value: "No" },
                { label: "Yes", value: "Yes" },
                {
                  label: "Not performed or untestable",
                  value: "Not performed or untestable",
                },
              ].map((option) => (
                <label key={option.value} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="sah_tcd_spasm"
                    value={option.value}
                    checked={formData.sah_tcd_spasm === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>

        <div className="block-2column">
          <label className="item_title_2col">
            TCD spasm의 symptomatic 여부 (sah_tcd_spasm_symptom)
          </label>
          <div className="input_2col">
            <div className="rad-group vertical">
              {[
                { label: "Asymptomatic", value: "Asymptomatic" },
                { label: "Symptomatic", value: "Symptomatic" },
                {
                  label: "Unknown (Deep sedation 등)",
                  value: "Unknown (Deep sedation 등)",
                },
              ].map((option) => (
                <label key={option.value} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="sah_tcd_spasm_symptom"
                    value={option.value}
                    checked={formData.sah_tcd_spasm_symptom === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            TCD spasm의 정도 (MFV 기준) (sah_tcd_spasm_degree_mfv)
          </label>
          <div className="input_2col">
            <div className="rad-group vertical">
              {[
                { label: "Mild", value: "Mild" },
                { label: "Moderate", value: "Moderate" },
                { label: "Severe", value: "Severe" },
              ].map((option) => (
                <label key={option.value} className="rad-label vertical">
                  <input
                    type="radio"
                    className="rad-input"
                    name="sah_tcd_spasm_degree_mfv"
                    value={option.value}
                    checked={formData.sah_tcd_spasm_degree_mfv === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>

        <div className="block-2column">
          <label className="item_title_2col">
            TCD spasm의 정도 (Lindegaard ratio 기준) (sah_tcd_spasm_degree_lr)
          </label>
          <div className="input_2col">
            <div className="rad-group vertical">
              {[
                { label: "Mild", value: "Mild" },
                { label: "Moderate", value: "Moderate" },
                { label: "Severe", value: "Severe" },
              ].map((option) => (
                <label key={option.value} className="rad-label vertical">
                  <input
                    type="radio"
                    className="rad-input"
                    name="sah_tcd_spasm_degree_lr"
                    value={option.value}
                    checked={formData.sah_tcd_spasm_degree_lr === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Vasospasm prophylaxis 관련 필드 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            Vasospasm prophylaxis 여부 (sah_vasospasm_prophylaxis)
          </label>
          <div className="input_2col">
            <div className="rad-group vertical">
              {[
                { label: "PO nimodipine", value: "PO nimodipine" },
                { label: "IV nimodipine", value: "IV nimodipine" },
                { label: "IV milrinone", value: "IV milrinone" },
                { label: "IV MgSO4", value: "IV MgSO4" },
                { label: "No", value: "No" },
              ].map((option) => (
                <label key={option.value} className="checkbox-label">
                  <input
                    type="checkbox"
                    name="sah_vasospasm_prophylaxis"
                    value={option.value}
                    checked={(
                      formData.sah_vasospasm_prophylaxis || []
                    ).includes(option.value)}
                    onChange={handleCheckboxChange}
                  />
                  <span className="checkbox-text">{option.label}</span>
                </label>
              ))}
            </div>
          </div>
        </div>

        <div className="block-2column">
          <label className="item_title_2col">
            DCI or Vasospasm에 대한 Induced HTN 치료 여부 (sah_induced_htn_tx)
          </label>
          <div className="input_2col">
            <div className="rad-group">
              {[
                { label: "No", value: "No" },
                { label: "Yes", value: "Yes" },
              ].map((option) => (
                <label key={option.value} className="rad-label vertical">
                  <input
                    type="radio"
                    className="rad-input"
                    name="sah_induced_htn_tx"
                    value={option.value}
                    checked={formData.sah_induced_htn_tx === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Rescue therapy 관련 필드 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            DCI or Vasospasm에 대한 rescue therapy 여부 (sah_rescue_vasopasm_tx)
          </label>
          <div className="input_2col">
            <div className="rad-group vertical">
              {[
                { label: "No", value: "No" },
                {
                  label: "Endovascular - Chemical",
                  value: "Endovascular - Chemical",
                },
                {
                  label: "Endovascular - Mechanical",
                  value: "Endovascular - Mechanical",
                },
                {
                  label: "Intrathecal therapy",
                  value: "Intrathecal therapy",
                },
              ].map((option) => (
                <label key={option.value} className="checkbox-label">
                  <input
                    type="checkbox"
                    name="sah_rescue_vasopasm_tx"
                    value={option.value}
                    checked={(formData.sah_rescue_vasopasm_tx || []).includes(
                      option.value
                    )}
                    onChange={handleCheckboxChange}
                  />
                  <span className="checkbox-text">{option.label}</span>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );

  // ICH/IVH 관련 필드
  const renderICHFields = () => (
    <>
      {/* ND1 섹션 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            ICH neurologic deterioration 일시 (ich_nd1_dt)
          </label>
          <div className="input_2col">
            <input
              type="text"
              name="ich_nd1_dt"
              placeholder="YYYY-MM-DD HH:MM"
              value={dtDisplay(formData.ich_nd1_dt)}
              onChange={(e) => {
                const input = e.target.value;
                const currentValue = dtDisplay(formData.ich_nd1_dt) || "";

                // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                if (input.length < currentValue.length) {
                  handleChange(e);
                  return;
                }

                // 숫자만 추출
                const numbers = input.replace(/\D/g, "");

                if (numbers.length <= 12) {
                  // 최대 12자리 (YYYYMMDDHHmm)
                  let formattedValue = numbers;

                  // 날짜 시간 포맷팅
                  if (numbers.length >= 4) {
                    formattedValue =
                      numbers.slice(0, 4) + "-" + numbers.slice(4);
                  }
                  if (numbers.length >= 6) {
                    formattedValue =
                      formattedValue.slice(0, 7) +
                      "-" +
                      formattedValue.slice(7);
                  }
                  if (numbers.length >= 8) {
                    formattedValue =
                      formattedValue.slice(0, 10) +
                      " " +
                      formattedValue.slice(10);
                  }
                  if (numbers.length >= 10) {
                    formattedValue =
                      formattedValue.slice(0, 13) +
                      ":" +
                      formattedValue.slice(13);
                  }

                  // 원래의 handleChange 함수 호출
                  handleChange({
                    target: {
                      name: "ich_nd1_dt",
                      value: formattedValue,
                    },
                  });
                }
              }}
            />
          </div>
        </div>
        <div className="block-2column" />
      </div>

      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            ICH neurologic deterioration 여부 (ich_nd1)
          </label>
          <div className="input_2col">
            <div className="rad-group">
              {[
                { label: "No", value: "No" },
                { label: "Yes", value: "Yes" },
              ].map((option) => (
                <label key={option.value} className="rad-label vertical">
                  <input
                    type="radio"
                    className="rad-input"
                    name="ich_nd1"
                    value={option.value}
                    checked={formData.ich_nd1 === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>

        <div className="block-2column">
          <label className="item_title_2col">
            ICH neurologic deterioration 원인 (ich_nd1_cause)
          </label>
          <div className="input_2col">
            <div className="rad-group vertical">
              {[
                { label: "Hematoma expansion", value: "Hematoma expansion" },
                { label: "Perihematomal edema", value: "Perihematomal edema" },
                { label: "Hydrocephalus", value: "Hydrocephalus" },
                { label: "Cerebral infarction", value: "Cerebral infarction" },
                { label: "Seizure", value: "Seizure" },
                {
                  label:
                    "Medical complications (i.e. Sepsis, Fever, Metabolic encephalopathry)",
                  value:
                    "Medical complications (i.e. Sepsis, Fever, Metabolic encephalopathry)",
                },
                { label: "Others, specify", value: "Others, specify" },
              ].map((option) => (
                <label key={option.value} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="ich_nd1_cause"
                    value={option.value}
                    checked={formData.ich_nd1_cause === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            ICH neurologic deterioration 원인_others (ich_nd1_cause_others)
          </label>
          <div className="input_2col">
            <input
              type="text"
              name="ich_nd1_cause_others"
              value={formData.ich_nd1_cause_others || ""}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>

      {/* ND2 섹션 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            ICH neurologic deterioration 일시 (ich_nd2_dt)
          </label>
          <div className="input_2col">
            <input
              type="text"
              name="ich_nd2_dt"
              placeholder="YYYY-MM-DD HH:MM"
              value={dtDisplay(formData.ich_nd2_dt)}
              onChange={(e) => {
                const input = e.target.value;
                const currentValue = dtDisplay(formData.ich_nd2_dt) || "";

                // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                if (input.length < currentValue.length) {
                  handleChange(e);
                  return;
                }

                // 숫자만 추출
                const numbers = input.replace(/\D/g, "");

                if (numbers.length <= 12) {
                  // 최대 12자리 (YYYYMMDDHHmm)
                  let formattedValue = numbers;

                  // 날짜 시간 포맷팅
                  if (numbers.length >= 4) {
                    formattedValue =
                      numbers.slice(0, 4) + "-" + numbers.slice(4);
                  }
                  if (numbers.length >= 6) {
                    formattedValue =
                      formattedValue.slice(0, 7) +
                      "-" +
                      formattedValue.slice(7);
                  }
                  if (numbers.length >= 8) {
                    formattedValue =
                      formattedValue.slice(0, 10) +
                      " " +
                      formattedValue.slice(10);
                  }
                  if (numbers.length >= 10) {
                    formattedValue =
                      formattedValue.slice(0, 13) +
                      ":" +
                      formattedValue.slice(13);
                  }

                  // 원래의 handleChange 함수 호출
                  handleChange({
                    target: {
                      name: "ich_nd2_dt",
                      value: formattedValue,
                    },
                  });
                }
              }}
            />
          </div>
        </div>
        <div className="block-2column" />
      </div>

      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            ICH neurologic deterioration 여부 (ich_nd2)
          </label>
          <div className="input_2col">
            <div className="rad-group">
              {[
                { label: "No", value: "No" },
                { label: "Yes", value: "Yes" },
              ].map((option) => (
                <label key={option.value} className="rad-label vertical">
                  <input
                    type="radio"
                    className="rad-input"
                    name="ich_nd2"
                    value={option.value}
                    checked={formData.ich_nd2 === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>

        <div className="block-2column">
          <label className="item_title_2col">
            ICH neurologic deterioration 원인 (ich_nd2_cause)
          </label>
          <div className="input_2col">
            <div className="rad-group vertical">
              {[
                { label: "Hematoma expansion", value: "Hematoma expansion" },
                { label: "Perihematomal edema", value: "Perihematomal edema" },
                { label: "Hydrocephalus", value: "Hydrocephalus" },
                { label: "Cerebral infarction", value: "Cerebral infarction" },
                { label: "Seizure", value: "Seizure" },
                {
                  label:
                    "Medical complications (i.e. Sepsis, Fever, Metabolic encephalopathry)",
                  value:
                    "Medical complications (i.e. Sepsis, Fever, Metabolic encephalopathry)",
                },
                { label: "Others, specify", value: "Others, specify" },
              ].map((option) => (
                <label key={option.value} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="ich_nd2_cause"
                    value={option.value}
                    checked={formData.ich_nd2_cause === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            ICH neurologic deterioration 원인_others (ich_nd2_cause_others)
          </label>
          <div className="input_2col">
            <input
              type="text"
              name="ich_nd2_cause_others"
              value={formData.ich_nd2_cause_others || ""}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>

      {/* ND3 섹션 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            ICH neurologic deterioration 일시 (ich_nd3_dt)
          </label>
          <div className="input_2col">
            <input
              type="text"
              name="ich_nd3_dt"
              placeholder="YYYY-MM-DD HH:MM"
              value={dtDisplay(formData.ich_nd3_dt)}
              onChange={(e) => {
                const input = e.target.value;
                const currentValue = dtDisplay(formData.ich_nd3_dt) || "";

                // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                if (input.length < currentValue.length) {
                  handleChange(e);
                  return;
                }

                // 숫자만 추출
                const numbers = input.replace(/\D/g, "");

                if (numbers.length <= 12) {
                  // 최대 12자리 (YYYYMMDDHHmm)
                  let formattedValue = numbers;

                  // 날짜 시간 포맷팅
                  if (numbers.length >= 4) {
                    formattedValue =
                      numbers.slice(0, 4) + "-" + numbers.slice(4);
                  }
                  if (numbers.length >= 6) {
                    formattedValue =
                      formattedValue.slice(0, 7) +
                      "-" +
                      formattedValue.slice(7);
                  }
                  if (numbers.length >= 8) {
                    formattedValue =
                      formattedValue.slice(0, 10) +
                      " " +
                      formattedValue.slice(10);
                  }
                  if (numbers.length >= 10) {
                    formattedValue =
                      formattedValue.slice(0, 13) +
                      ":" +
                      formattedValue.slice(13);
                  }

                  // 원래의 handleChange 함수 호출
                  handleChange({
                    target: {
                      name: "ich_nd3_dt",
                      value: formattedValue,
                    },
                  });
                }
              }}
            />
          </div>
        </div>
        <div className="block-2column" />
      </div>

      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            ICH neurologic deterioration 여부 (ich_nd3)
          </label>
          <div className="input_2col">
            <div className="rad-group">
              {[
                { label: "No", value: "No" },
                { label: "Yes", value: "Yes" },
              ].map((option) => (
                <label key={option.value} className="rad-label vertical">
                  <input
                    type="radio"
                    className="rad-input"
                    name="ich_nd3"
                    value={option.value}
                    checked={formData.ich_nd3 === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>

        <div className="block-2column">
          <label className="item_title_2col">
            ICH neurologic deterioration 원인 (ich_nd3_cause)
          </label>
          <div className="input_2col">
            <div className="rad-group vertical">
              {[
                { label: "Hematoma expansion", value: "Hematoma expansion" },
                { label: "Perihematomal edema", value: "Perihematomal edema" },
                { label: "Hydrocephalus", value: "Hydrocephalus" },
                { label: "Cerebral infarction", value: "Cerebral infarction" },
                { label: "Seizure", value: "Seizure" },
                {
                  label:
                    "Medical complications (i.e. Sepsis, Fever, Metabolic encephalopathry)",
                  value:
                    "Medical complications (i.e. Sepsis, Fever, Metabolic encephalopathry)",
                },
                { label: "Others, specify", value: "Others, specify" },
              ].map((option) => (
                <label key={option.value} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="ich_nd3_cause"
                    value={option.value}
                    checked={formData.ich_nd3_cause === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            ICH neurologic deterioration 원인_others (ich_nd3_cause_others)
          </label>
          <div className="input_2col">
            <input
              type="text"
              name="ich_nd3_cause_others"
              value={formData.ich_nd3_cause_others || ""}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>

      {/* Hematoma expansion 1 */}
      <h3 className="section-subtitle">ICH Hematoma expansion</h3>
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            Hematoma expansion (ich_he1)
          </label>
          <div className="input_2col">
            <div className="rad-group">
              {[
                { label: "No", value: "No" },
                { label: "Yes", value: "Yes" },
              ].map((option) => (
                <label key={option.value} className="rad-label vertical">
                  <input
                    type="radio"
                    className="rad-input"
                    name="ich_he1"
                    value={option.value}
                    checked={formData.ich_he1 === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>

        <div className="block-2column">
          <label className="item_title_2col">
            Hematoma expansion 발생 후 치료 (ich_he1_action)
          </label>
          <div className="input_2col">
            <div className="rad-group vertical">
              {[
                { label: "None", value: "None" },
                {
                  label: "Medical therapy only",
                  value: "Medical therapy only",
                },
                {
                  label: "Any surgical therapy",
                  value: "Any surgical therapy",
                },
              ].map((option) => (
                <label key={option.value} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="ich_he1_action"
                    value={option.value}
                    checked={formData.ich_he1_action === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            Hematoma expansion 발생 일시 (ich_he1_dt)
          </label>
          <div className="input_2col">
            <input
              type="text"
              name="ich_he1_dt"
              placeholder="YYYY-MM-DD HH:MM"
              value={dtDisplay(formData.ich_he1_dt)}
              onChange={(e) => {
                const input = e.target.value;
                const currentValue = dtDisplay(formData.ich_he1_dt) || "";

                // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                if (input.length < currentValue.length) {
                  handleChange(e);
                  return;
                }

                // 숫자만 추출
                const numbers = input.replace(/\D/g, "");

                if (numbers.length <= 12) {
                  // 최대 12자리 (YYYYMMDDHHmm)
                  let formattedValue = numbers;

                  // 날짜 시간 포맷팅
                  if (numbers.length >= 4) {
                    formattedValue =
                      numbers.slice(0, 4) + "-" + numbers.slice(4);
                  }
                  if (numbers.length >= 6) {
                    formattedValue =
                      formattedValue.slice(0, 7) +
                      "-" +
                      formattedValue.slice(7);
                  }
                  if (numbers.length >= 8) {
                    formattedValue =
                      formattedValue.slice(0, 10) +
                      " " +
                      formattedValue.slice(10);
                  }
                  if (numbers.length >= 10) {
                    formattedValue =
                      formattedValue.slice(0, 13) +
                      ":" +
                      formattedValue.slice(13);
                  }

                  // 원래의 handleChange 함수 호출
                  handleChange({
                    target: {
                      name: "ich_he1_dt",
                      value: formattedValue,
                    },
                  });
                }
              }}
            />
          </div>
        </div>
        <div className="block-2column" />
      </div>

      {/* Hematoma expansion 2 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            Hematoma expansion (ich_he2)
          </label>
          <div className="input_2col">
            <div className="rad-group">
              {[
                { label: "No", value: "No" },
                { label: "Yes", value: "Yes" },
              ].map((option) => (
                <label key={option.value} className="rad-label vertical">
                  <input
                    type="radio"
                    className="rad-input"
                    name="ich_he2"
                    value={option.value}
                    checked={formData.ich_he2 === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>

        <div className="block-2column">
          <label className="item_title_2col">
            Hematoma expansion 발생 후 치료 (ich_he2_action)
          </label>
          <div className="input_2col">
            <div className="rad-group vertical">
              {[
                { label: "None", value: "None" },
                {
                  label: "Medical therapy only",
                  value: "Medical therapy only",
                },
                {
                  label: "Any surgical therapy",
                  value: "Any surgical therapy",
                },
              ].map((option) => (
                <label key={option.value} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="ich_he2_action"
                    value={option.value}
                    checked={formData.ich_he2_action === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            Hematoma expansion 발생 일시 (ich_he2_dt)
          </label>
          <div className="input_2col">
            <input
              type="text"
              name="ich_he2_dt"
              placeholder="YYYY-MM-DD HH:MM"
              value={dtDisplay(formData.ich_he2_dt)}
              onChange={(e) => {
                const input = e.target.value;
                const currentValue = dtDisplay(formData.ich_he2_dt) || "";

                // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                if (input.length < currentValue.length) {
                  handleChange(e);
                  return;
                }

                // 숫자만 추출
                const numbers = input.replace(/\D/g, "");

                if (numbers.length <= 12) {
                  // 최대 12자리 (YYYYMMDDHHmm)
                  let formattedValue = numbers;

                  // 날짜 시간 포맷팅
                  if (numbers.length >= 4) {
                    formattedValue =
                      numbers.slice(0, 4) + "-" + numbers.slice(4);
                  }
                  if (numbers.length >= 6) {
                    formattedValue =
                      formattedValue.slice(0, 7) +
                      "-" +
                      formattedValue.slice(7);
                  }
                  if (numbers.length >= 8) {
                    formattedValue =
                      formattedValue.slice(0, 10) +
                      " " +
                      formattedValue.slice(10);
                  }
                  if (numbers.length >= 10) {
                    formattedValue =
                      formattedValue.slice(0, 13) +
                      ":" +
                      formattedValue.slice(13);
                  }

                  // 원래의 handleChange 함수 호출
                  handleChange({
                    target: {
                      name: "ich_he2_dt",
                      value: formattedValue,
                    },
                  });
                }
              }}
            />
          </div>
        </div>
        <div className="block-2column" />
      </div>

      {/* Hematoma expansion 3 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            Hematoma expansion (ich_he3)
          </label>
          <div className="input_2col">
            <div className="rad-group">
              {[
                { label: "No", value: "No" },
                { label: "Yes", value: "Yes" },
              ].map((option) => (
                <label key={option.value} className="rad-label vertical">
                  <input
                    type="radio"
                    className="rad-input"
                    name="ich_he3"
                    value={option.value}
                    checked={formData.ich_he3 === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>

        <div className="block-2column">
          <label className="item_title_2col">
            Hematoma expansion 발생 후 치료 (ich_he3_action)
          </label>
          <div className="input_2col">
            <div className="rad-group vertical">
              {[
                { label: "None", value: "None" },
                {
                  label: "Medical therapy only",
                  value: "Medical therapy only",
                },
                {
                  label: "Any surgical therapy",
                  value: "Any surgical therapy",
                },
              ].map((option) => (
                <label key={option.value} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="ich_he3_action"
                    value={option.value}
                    checked={formData.ich_he3_action === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            Hematoma expansion 발생 일시 (ich_he3_dt)
          </label>
          <div className="input_2col">
            <input
              type="text"
              name="ich_he3_dt"
              placeholder="YYYY-MM-DD HH:MM"
              value={dtDisplay(formData.ich_he3_dt)}
              onChange={(e) => {
                const input = e.target.value;
                const currentValue = dtDisplay(formData.ich_he3_dt) || "";

                // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                if (input.length < currentValue.length) {
                  handleChange(e);
                  return;
                }

                // 숫자만 추출
                const numbers = input.replace(/\D/g, "");

                if (numbers.length <= 12) {
                  // 최대 12자리 (YYYYMMDDHHmm)
                  let formattedValue = numbers;

                  // 날짜 시간 포맷팅
                  if (numbers.length >= 4) {
                    formattedValue =
                      numbers.slice(0, 4) + "-" + numbers.slice(4);
                  }
                  if (numbers.length >= 6) {
                    formattedValue =
                      formattedValue.slice(0, 7) +
                      "-" +
                      formattedValue.slice(7);
                  }
                  if (numbers.length >= 8) {
                    formattedValue =
                      formattedValue.slice(0, 10) +
                      " " +
                      formattedValue.slice(10);
                  }
                  if (numbers.length >= 10) {
                    formattedValue =
                      formattedValue.slice(0, 13) +
                      ":" +
                      formattedValue.slice(13);
                  }

                  // 원래의 handleChange 함수 호출
                  handleChange({
                    target: {
                      name: "ich_he3_dt",
                      value: formattedValue,
                    },
                  });
                }
              }}
            />
          </div>
        </div>
        <div className="block-2column" />
      </div>
    </>
  );

  return (
    <section className="vip-form-section">
      <div className="basic-info-fieldset">
        <h3 className="section-subtitle">{getSectionTitle()}</h3>

        {/* 뇌손상 종류별 필드 */}
        {formData.index_injury === "TBI" && renderTBIFields()}
        {formData.index_injury === "SAH (ruptured aneurysm)" &&
          renderSAHFields()}
        {formData.index_injury === "ICH (primary, secondary) / IVH" &&
          renderICHFields()}

        {/* Completion Status - 모든 조건에서 표시 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              Completion status_5 (early_outcome_status)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "Not started", value: "Not started" },
                  { label: "In process", value: "In process" },
                  { label: "Complete", value: "Complete" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="early_outcome_status"
                      value={option.value}
                      checked={formData.early_outcome_status === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="block-2column" />
        </div>
      </div>
    </section>
  );
};

export default EarlyOutcome;
